import AccordionSummary from "@mui/material/AccordionSummary"
import styled from "styled-components"

export const AccordingSummaryDS = styled(AccordionSummary)``
